import { setGeo, setIcons, setLines, setScatter, formatRegions } from "../tools";
import china from '../json/china.json';
import * as echarts from 'echarts';
import './index.css';

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeMap',
  props: {
    id: { type: String, default: () => (`a-e-map-${Math.random().toString().substring(2)}`) },
    delay: { type: Number, default: () => 800 },
    area: { type: String, default: () => '' },
    site: { type: String, default: () => '' },
    data: { type: Array, default: () => [] },
    zoom: { type: Number | String, default: () => 1.2 },
    option: { type: Object, default: () => ({}) },
    background: { type: String, default: () => '#07a1fe' },
    acticeBackground: { type: String, default: () => 'red' },
    enableScale: { type: Boolean, default: () => true },
  },
  data() {
    return {
      scale: this.zoom,
      charts: null,
      config: null,
      regions: null,
    }
  },
  watch: {
    option() {
      this.create();
    },
    area() {
      this.create();
    },
    data(next, prev) {
      if (JSON.stringify(next) != JSON.stringify(prev)) this.create();
    },
  },
  mounted() {
    this.create();
  },
  methods: {
    create() {
      let area = this.area != '' ? JSON.parse(this.area) : china;
      if (area) {
        echarts.registerMap(this.id, area);
        this.regions = formatRegions(area, this.background);
        let sites = [];
        this.data.map(a => {
          this.regions.map(b => {
            if ((a.stationLocation.city == b.name) || (b.name.includes(a.stationLocation.city))) sites.push({ ...b, ...a });
          });
        });
        const series = [
          ...setIcons(sites, '430100'),
          ...setLines(this.regions, '430100'),
          ...setScatter(this.regions, '430100'),
        ];
        this.config = {
          geo: setGeo(this.id, this.regions),
          grid: {
            containLabel: this.enableScale,
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}',
          },
          dataRange: {
            x: 'right',
            y: 'bottom',
            splitList: [
              { start: 10, end: 200, label: '范围1', color: 'orange' },
              { start: 5, end: 5, label: '范围2', color: '#1afa29' },
            ],
            color: ['#1afa29', 'orange'],
            textStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          series,
          ...this.option,
        };
      }
    },
    action(charts, option) {
      if (charts) {
        this.charts = charts;
        if (this.regions && this.regions.length > 0) {
          this.charts.off('click');
          this.charts.on('click', region => {
            let area = region.region || region.data || null;
            this.regions.forEach(a => {
              a.selected = false;
              if (area && (a.id == area.id)) a.selected = !area.selected;
            });
            this.select(area);
          });
          this.charts.off('georoam');
          this.charts.on('georoam', ({ zoom }) => zoom && (this.scale = Number((this.scale * zoom.toFixed(1)).toFixed(1))));
          (option && option.geo && option.geo.zoom) ? option.geo.zoom = this.scale : () => null;
        }
      }
    },
    select(a) {
      this.$emit('select', a && !a.selected && a);
    },
  },
  render() {
    const { width = '100%', height = '100%' } = this.$attrs;
    return (<Aecharts type="map" width={width} height={height} option={this.config} on-action={this.action} />);
  }
}